"use strict";
(self["webpackChunkshop_chunks"] = self["webpackChunkshop_chunks"] || []).push([[714],{

/***/ 5714:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CreatorVideo)
/* harmony export */ });
if (!customElements.get('creator-video')) {
  customElements.define(
    'creator-video',
    class CustomDialog extends HTMLElement {
      constructor() {
        super()
        this.video = this.querySelector('video')
        this.playButton = this.querySelector('button')
        this.togglePlay = this.togglePlay.bind(this)
        this.playButton.addEventListener('click', this.togglePlay)
      }

      togglePlay() {
        const { video, playButton } = this
        if (video.paused) {
          video.play()
          playButton.dataset.isPlaying = 'true'
        } else {
          video.pause()
          playButton.dataset.isPlaying = 'false'
        }
      }
    }
  )
}

function CreatorVideo() {
  return null
}


/***/ })

}]);